import { motion } from 'framer-motion';
import type { PublicShowcase } from '../lib/api';
import { monthLabel } from '../lib/api';

/**
 * Real-time telemetry band. Pulls live from the public showcase
 * endpoint, never caches beyond 30 seconds at the edge. Renders the
 * three most honest numbers a buyer could ask for: "how far are we,"
 * "when do I get the key," and "when was this last touched."
 */
export function LiveBand({ data }: { data: PublicShowcase }) {
  const delivery = monthLabel(data.estimatedDeliveryMonth);

  return (
    <section className="relative border-t border-line bg-bg py-16 sm:py-24">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-6 sm:px-12 md:grid-cols-3 md:gap-16 lg:px-20">
        <div>
          <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-accent">
            Andamento agora
          </p>
          <p className="mt-4 font-display text-5xl font-light italic tracking-tightest text-ink tabular-nums">
            {data.progressPercent}
            <span className="text-ink-subtle">%</span>
          </p>
          {data.currentStageLabel && (
            <p className="mt-3 text-sm text-ink-muted">
              {data.currentStageLabel}
            </p>
          )}
          <div className="mt-5 h-[2px] w-full overflow-hidden rounded-full bg-white/10">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${data.progressPercent}%` }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              className="h-full bg-accent"
            />
          </div>
        </div>

        {delivery && (
          <div>
            <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-accent">
              Entrega prevista
            </p>
            <p className="mt-4 font-display text-3xl font-light italic capitalize tracking-tight text-ink">
              {delivery}
            </p>
            <p className="mt-3 text-sm text-ink-muted">
              Estimativa atualizada conforme o avanço da obra.
            </p>
          </div>
        )}

        <div>
          <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-accent">
            Última atualização
          </p>
          <p className="mt-4 font-display text-3xl font-light italic tracking-tight text-ink tabular-nums">
            {new Date(data.updatedAt).toLocaleDateString('pt-BR', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            })}
          </p>
          <p className="mt-3 text-sm text-ink-muted">
            Toda foto e etapa desta página é curada pelo gestor da obra
            em tempo real.
          </p>
        </div>
      </div>
    </section>
  );
}
